import L from "leaflet";

export const STATUS = {
  moving: { label: "Jedzie", color: "#059669", pill: "bg-emerald-50 text-emerald-700 ring-emerald-200", dot: "bg-emerald-500 animate-pulse" },
  stopped: { label: "Postój", color: "#D97706", pill: "bg-amber-50 text-amber-700 ring-amber-200", dot: "bg-amber-500" },
  stale: { label: "Słaby sygnał", color: "#71717A", pill: "bg-zinc-100 text-zinc-600 ring-zinc-200", dot: "bg-zinc-400" },
  offline: { label: "Brak sygnału", color: "#3F3F46", pill: "bg-zinc-800 text-zinc-200 ring-zinc-700", dot: "bg-zinc-600" },
};

export const initials = (name = "") =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "K";

export const timeAgo = (iso) => {
  if (!iso) return "nigdy";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 10) return "teraz";
  if (s < 60) return `${s} s temu`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min temu`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} godz. temu`;
  return new Date(iso).toLocaleString("pl-PL", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("pl-PL", { hour: "2-digit", minute: "2-digit" }) : "—");

export const plParcels = (n) => {
  const m10 = n % 10, m100 = n % 100;
  if (n === 1) return "1 paczka";
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return `${n} paczki`;
  return `${n} paczek`;
};

export const courierIcon = (c, selected) => {
  const s = STATUS[c.status] || STATUS.offline;
  const size = selected ? 46 : 38;
  const heading = c.heading != null && c.status === "moving" ? c.heading : null;
  const arrow = heading != null
    ? `<div style="position:absolute;inset:-7px;display:flex;justify-content:center;transform:rotate(${heading}deg)"><div style="width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:9px solid ${s.color}"></div></div>`
    : "";
  const html = `<div style="position:relative;width:${size}px;height:${size}px;${c.status === "offline" ? "opacity:.65" : ""}">
      ${arrow}
      <div style="width:100%;height:100%;border-radius:9999px;background:${s.color};color:#fff;display:flex;align-items:center;justify-content:center;font:900 ${selected ? 15 : 13}px/1 'Space Grotesk',system-ui,sans-serif;letter-spacing:.02em;border:3px solid ${selected ? "#18181b" : "#fff"};box-shadow:0 4px 14px rgba(0,0,0,.35)">${initials(c.name)}</div>
      ${c.status === "moving" ? `<div class="courier-ping" style="border-color:${s.color}"></div>` : ""}
    </div>`;
  return L.divIcon({ html, className: "courier-marker", iconSize: [size, size], iconAnchor: [size / 2, size / 2], popupAnchor: [0, -size / 2] });
};
